import { memo } from "react"

const IconPlans = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="32" viewBox="0 0 31 32" fill="none">
      <rect y="0.666016" width="30.6667" height="30.6667" rx="7.11111" fill="#7B78E1" fill-opacity="0.3" />
      <path
        d="M19.0257 13.8681L11.584 9.50977"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.026 13.8672V22.4922"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.334 20.2583L7.83398 16"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.334 20.2586L22.834 15.9336"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.584 13.8348L19.084 9.50977"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5846 13.834V22.4923"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.06641 11.8047L15.3347 16.0005L22.6022 11.8047"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.3346 16V24.3917"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.834 19.3293V12.6693C22.834 12.0501 22.504 11.4785 21.9682 11.1693L16.1998 7.8393C15.664 7.53013 15.004 7.53013 14.4682 7.8393L8.69982 11.1693C8.16398 11.4785 7.83398 12.0501 7.83398 12.6693V19.3293C7.83398 19.9485 8.16398 20.5201 8.69982 20.8293L14.4682 24.1593C15.004 24.4685 15.664 24.4685 16.1998 24.1593L21.9682 20.8293C22.504 20.5201 22.834 19.9485 22.834 19.3293Z"
        stroke="#002C98"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default memo(IconPlans)
